module.exports = __webpack_public_path__ + "static/bs1-5523608c9811f6901286ebd63af480ad.png";